import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { selectJobsListItems } from "../../../redux/jobs/selector";
import storePersist from "../../../redux/storePersist";
import _ from "lodash";
import { jobs } from "../../../redux/jobs/action";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/hooks";
import { format } from "../../../common/services/common.service";

const JobList = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const itemsData = useSelector(selectJobsListItems)
    const [pageSize, setPageSize] = useState(10);
    const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'TransportAgent']);

    const fetchJobs = async () => {
        await dispatch(jobs.resetAction({ actionType: 'list' }))
        await dispatch(jobs.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`, entity: 'jobs', jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "CreatedOnUtc",
                "SortOrder": "desc",
                "Filters": [
                    {
                        "FieldName": "TransportAgentId",
                        "FilterOperatorId": 1,
                        "FieldValue": roleData?.Id,
                        "FieldType": "number"
                    }]
            }
        }))
    }



    useEffect(() => {

        fetchJobs()
    }, [pageData, pageSize])


    const handleMore = (data: any) => {
        navigate("/transport-agent/logistics/transport/jobs")
    }

    const formatAddress = (fullAddress): any => {
        const address = `${fullAddress?.address?.building} , ${fullAddress?.address?.locality} , ${fullAddress?.address?.city} , ${fullAddress?.address?.country} , ${fullAddress?.address?.state} - ${fullAddress?.address?.area_code}`;
        if (!address) return '';
        return address.length > 25 ? `${address.substring(0, 25)}...` : address;
    };
    const ToolTipAddress = (fullAddress): any => {
        const address = `${fullAddress?.address?.building} , ${fullAddress?.address?.locality} , ${fullAddress?.address?.city} , ${fullAddress?.address?.country} , ${fullAddress?.address?.state} - ${fullAddress?.address?.area_code}`;
        if (!address) return '';
        return address?.length > 25 ? address : '';
    };

    return (
        <>
            {itemsData?.isLoading ? <h1>Loading...</h1>
                :
                <>


                    <div className="flex items-center justify-end items-end mb-4">

                        <button className="border border-neutral-800 px-4 py-2 rounded" onClick={handleMore}>
                            More Details..
                        </button>
                    </div>
                    <div className="overflow-auto w-full">
                        <table className="hidden md:table min-w-full text-sm text-left bg-red-50 p-2 rounded-md">
                            <thead className="w-auto text-center">
                                <tr className="bg-red-100 h-12 leading-normal">
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Order Id</th>
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Pickup</th>
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Drop</th>
                                    <th className="py-3 px-6 text-left border-r border-gray-100">Schedule Date & Time</th>

                                </tr>
                            </thead>
                            <tbody>
                                {itemsData?.result?.items?.map((data) => (
                                    <tr key={data.Message.Id} className=" border-b even:bg-[#F8F9FAFF] odd:bg-white">
                                        <td className="px-5 py-2">{data?.Message?.OrderId}</td>
                                        <td className="px-5 py-2 cursor-pointer" title={ToolTipAddress(data?.Message?.PickupInfo?.location)}>{formatAddress(data?.Message?.PickupInfo?.location)}</td>
                                        <td className=" px-5 py-2 cursor-pointer" title={ToolTipAddress(data?.Message?.DeliveryInfo?.location)}>{formatAddress(data?.Message?.DeliveryInfo?.location)}</td>
                                        <td className="px-5 py-2">{format(data?.Message?.ShipmentInfo?.DeliveryDateUtc)}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="block md:hidden space-y-4">
                            {itemsData?.result?.items?.map((data) => (
                                <div
                                    key={data.Message.Id}
                                    className="bg-white rounded-xl shadow-md border border-gray-100 p-4 hover:shadow-lg transition-shadow duration-300"
                                >
                                    {/* Header */}
                                    <div className="flex items-center justify-between border-b border-gray-100 pb-2 mb-3">
                                        <h3 className="text-lg font-semibold text-gray-800">
                                            # {data?.Message?.OrderId}
                                        </h3>
                                        <span className="text-xs px-2 py-1 rounded-full bg-red-100 text-red-600 font-medium">
                                            Scheduled
                                        </span>
                                    </div>

                                    {/* Details */}
                                    <div className="space-y-2 text-sm text-gray-700">
                                        <div>
                                            <span className="font-semibold text-gray-600">Pickup:</span>
                                            <div className="text-gray-800">{formatAddress(data?.Message?.PickupInfo?.location)}</div>
                                        </div>
                                        <div>
                                            <span className="font-semibold text-gray-600">Drop:</span>
                                            <div className="text-gray-800">{formatAddress(data?.Message?.DeliveryInfo?.location)}</div>
                                        </div>
                                        <div>
                                            <span className="font-semibold text-gray-600">Schedule:</span>
                                            <div className="text-gray-800">{format(data?.Message?.ShipmentInfo?.DeliveryDateUtc)}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>

                </>
            }
        </>



    );
};

export default JobList;


